import React from "react"
import isUrl from "is-url"
import { getEventTransfer } from "@convertkit/slate-react"
import ToolbarButton from "./toolbar-button"
import LinkIconButton from "./link-icon-button"
import { useInheritedTheme } from "../../hooks/use-theme"
import { InlineChromiumBugfix } from "../inline-chromium-bugfix"

const handledTransferType = type => type == "text" || type == "html"

export default () => ({
  commands: {
    insertLink: (editor, { href, ...attributes }, options = {}) => {
      const { keepSelection = false } = options

      const originalSelection = editor.value.selection

      if (editor.isLink(editor.value)) {
        const link = editor.getLink()
        editor.moveToRangeOfNode(link)
        editor.unwrapLink()
      } else if (editor.value.selection.isCollapsed) {
        const startOffset = editor.value.selection.start.offset
        const endOffset = startOffset + href.length

        editor
          .insertText(href)
          .moveAnchorTo(startOffset)
          .moveFocusTo(endOffset)
      }

      editor.wrapLink({ href, ...attributes })

      // when originalSelection was collapsed we want the cursor to be moved to the end of the link
      if (!keepSelection || originalSelection.isCollapsed) {
        editor.moveToEnd()
      }
    },
    wrapLink: (editor, { href, ...attributes }) => {
      editor.wrapInline({
        type: "link",
        data: { href, ...attributes }
      })
    },
    unwrapLink: editor => {
      editor.unwrapInline("link")
    }
  },
  queries: {
    isLink(editor) {
      return editor.value.inlines.some(inline => inline.type === "link")
    },
    getHref(editor) {
      const link = editor.value.inlines.find(inline => inline.type === "link")
      return (link && link.data.get("href")) || ""
    },
    getLink(editor) {
      return editor.value.inlines.find(inline => inline.type === "link")
    }
  },
  onPaste(event, editor, next) {
    const transfer = getEventTransfer(event)

    if (!handledTransferType(transfer.type)) return next()
    if (!isUrl(transfer.text)) return next()

    return editor.insertLink({ href: transfer.text })
  },
  renderNode(props, editor, next) {
    const { attributes, children, node } = props
    switch (node.type) {
      case "link":
        return (
          <Link attributes={attributes} node={node}>
            {children}
          </Link>
        )
      default:
        return next()
    }
  }
})

function Link({ attributes, node, children }) {
  const { find } = useInheritedTheme()

  return (
    <a
      {...attributes}
      className="email-link"
      style={{ color: find("link", "color") }}
      href={node.data.get("href")}
    >
      <InlineChromiumBugfix />
      {children}
      <InlineChromiumBugfix />
    </a>
  )
}

export { ToolbarButton, LinkIconButton }
